/** Light "paper" canvas for read-only email bodies — keeps HTML readable in dark app theme. */
export const EMAIL_MESSAGE_CANVAS_CLASS =
  'rounded-lg border bg-white text-gray-900 border-gray-200 dark:bg-white dark:text-gray-900 dark:border-gray-300';

export const EMAIL_MESSAGE_PLAIN_TEXT_CLASS =
  'whitespace-pre-wrap font-sans text-sm leading-relaxed text-gray-900 dark:text-gray-900';

/** Editable compose/signature body — always light so typed and pasted email HTML stays readable. */
export const EMAIL_COMPOSE_EDITOR_CANVAS_CLASS =
  'bg-white text-gray-900 caret-gray-900 dark:bg-white dark:text-gray-900 dark:caret-gray-900';
